export var customJsApiRelativePath = "/helpcenter/snippets/js";
export var customJsApiRelativePathV2 = "/helpcenter/snippets/js/v2";
export var createCustomJsApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + customJsApiRelativePath;
    var apiUrlV2 = "" + baseUrl + customJsApiRelativePathV2;
    return {
        getCustomJs: function (brandId) {
            return http.get("" + apiUrl + (brandId ? "?brandId=" + brandId : ''));
        },
        updateCustomJs: function (dto) { return http.put("" + apiUrl, dto.data); },
        getCustomJsV2: function (brandId) {
            return http.get("" + apiUrlV2 + (brandId ? "?brandId=" + brandId : ''));
        },
        updateCustomJsV2: function (dto) { return http.put("" + apiUrlV2, dto.data); },
    };
};
//# sourceMappingURL=index.js.map